import {
  Directive,
  ElementRef,
  // forwardRef,
  HostListener,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  selector: '[cardExpiry]',
  standalone: true,
  // providers: [
  //   {
  //     provide: NG_VALUE_ACCESSOR,
  //     useExisting: forwardRef(() => CardExpiryDirective),
  //     multi: true,
  //   },
  // ],
})
export class CardExpiryDirective implements ControlValueAccessor, OnChanges {
  @Input('cardExpiry') enabled: boolean = true;

  private onChange = (value: any) => {};
  private onTouched = () => {};
  private rawValue = '';

  constructor(private el: ElementRef<HTMLInputElement>) {}

  ngOnChanges(changes: SimpleChanges): void {
    try {
      if (changes['enabled'] && !this.enabled) {
        this.el.nativeElement.value = this.rawValue;
      }
    } catch (error) {
      console.error('Error in CardExpiryDirective ngOnChanges:', error);
    }
  }

  writeValue(value: any): void {
    this.rawValue = value || '';
    const viewValue = this.enabled ? this.format(this.rawValue) : this.rawValue;
    this.el.nativeElement.value = viewValue;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    if (!this.enabled) return;

    const input = event.target as HTMLInputElement;
    const digits = input.value.replace(/\D/g, '').slice(0, 4); // max 4 digits
    this.rawValue = digits;

    const formatted = this.format(digits);
    input.value = formatted;

    this.onChange(digits); // emit raw MMYY value
  }

  @HostListener('blur')
  onBlur(): void {
    this.onTouched();
  }

  private format(value: string): string {
    if (value.length <= 2) return value;
    return `${value.slice(0, 2)}/${value.slice(2)}`;
  }
}
